import React from 'react'
import useStudentColumns from 'hooks/useStudentColumns'
import { useSortBy, useTable, usePagination } from 'react-table'
import Pagination from 'components/Pagination/Pagination'

const StudentsTable2 = ({ students, onDelete }) => {
  const columns = useStudentColumns({
    onDelete,
  })

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    state: {
      pageIndex,
    },
  } = useTable({
    columns,
    data: students,
  }, useSortBy, usePagination)

  return (
    <>
      <div className="table-responsive mb-5">
        <table {...getTableProps()} className="table table-bordered">
          <thead>
            {headerGroups.map((headerGroup) => {
              const { key, ...props } = headerGroup.getHeaderGroupProps()

              return (
                <tr {...props} key={key}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())} key={column.id}>
                      {column.render('Header')}
                    </th>
                  ))}
                </tr>
              )
            })}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row)

              return (
                <tr {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell, index) => (
                    <td valign="middle" {...cell.getCellProps()} key={`cell-${index}`}>
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <Pagination 
        page={pageIndex}
        pageCount={pageCount}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        onClick={gotoPage}
      />
    </>
  )
}

export default StudentsTable2
